"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Search_1 = __importDefault(require("@kyruus/react-ikons/Search"));
const Button = ({ template, displayDictionary }) => {
    const label = displayDictionary['button.label'];
    const icon = displayDictionary['button.icon'];
    const iconAriaLabel = displayDictionary['button.aria_label'];
    const Container = (0, react_1.useMemo)(() => (0, styled_1.default)('div') `
        ${template}
      `, [template]);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement("button", { type: "submit", "data-testid": "sw-button", "data-ref": "button-search", "aria-label": iconAriaLabel },
            icon && react_1.default.createElement(Search_1.default, { "aria-hidden": true, size: "1.3em" }),
            label && react_1.default.createElement("span", null, label))));
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map